import React from "react";
import { Card, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface IProps {
  institutionsCount: number;
  usersCount: number;
  incidentsCount: number;
}

const Widgets = ({
  institutionsCount,
  usersCount,
  incidentsCount,
}: IProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <>
      <Col md={4} sm={6}>
        <Card
          className={"statistics-card-1 overflow-hidden cursor-pointer"}
          onClick={() => navigate("/institutions")}
          style={{ cursor: 'pointer' }}
        >
          <Card.Body>
            <img
              src={"/assets/images/widget/img-status-4.svg"}
              alt="img"
              width={100}
              className="img-fluid img-bg"
            />
            <h5 className={"mb-4"}>{t("dashboard.totalInstitutions")}</h5>
            <div className="d-flex align-items-center mt-3">
              <h3 className={"f-w-300 d-flex align-items-center m-b-0"}>
                {institutionsCount}
              </h3>
            </div>
            <p className={"text-muted mb-2 text-sm mt-3"}>
              {t("dashboard.institutionsDescription")}
            </p>
          </Card.Body>
        </Card>
      </Col>
      <Col md={4} sm={6}>
        <Card
          className={"statistics-card-1 overflow-hidden cursor-pointer"}
          onClick={() => navigate("/users")}
          style={{ cursor: 'pointer' }}
        >
          <Card.Body>
            <img
              src={"/assets/images/widget/img-status-5.svg"}
              alt="img"
              width={100}
              className="img-fluid img-bg"
            />
            <h5 className={"mb-4"}>{t("dashboard.totalUsers")}</h5>
            <div className="d-flex align-items-center mt-3">
              <h3 className={"f-w-300 d-flex align-items-center m-b-0"}>
                {usersCount}
              </h3>
            </div>
            <p className={"text-muted mb-2 text-sm mt-3"}>
              {t("dashboard.usersDescription")}
            </p>
          </Card.Body>
        </Card>
      </Col>
      <Col md={4} sm={6}>
        <Card
          className={"statistics-card-1 overflow-hidden bg-brand-color-3 cursor-pointer"}
          onClick={() => navigate("/incidents")}
          style={{ cursor: 'pointer' }}
        >
          <Card.Body>
            <img
              src={"/assets/images/widget/img-status-6.svg"}
              alt="img"
              width={100}
              className="img-fluid img-bg"
            />
            <h5 className={"text-white mb-4"}>{t("dashboard.totalIncidents")}</h5>
            <div className="d-flex align-items-center mt-3">
              <h3
                className={"text-white f-w-300 d-flex align-items-center m-b-0"}
              >
                {incidentsCount}
              </h3>
            </div>
            <p className={"text-white text-opacity-75 mb-2 text-sm mt-3"}>
              {t("dashboard.incidentsDescription")}
            </p>
          </Card.Body>
        </Card>
      </Col>
    </>
  );
};

export default Widgets;
